<template>

  <div class="col  mt-3">
    <div class="el-button-group mb-3">

      <router-link tag="el-button" class="el-button--medium" active-class="el-button--primary"
                   to="/gelir/odeme" type="default">{{$t('fatura.tahsilat')}}
      </router-link>
      <router-link tag="el-button" class="el-button--medium" active-class="el-button--primary"
                   to="/gelir/fatura" type="default">{{$t('fatura.fatura')}}
      </router-link>

    </div>
    <router-view></router-view>
  </div>

</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gelir/_route.vue